import { ReactElement } from 'react';

type ConditonalWrapperProps = {
  children: ReactElement;
  condition: boolean;
  wrapper: (children: ReactElement) => ReactElement;
};

const ConditonalWrapper = ({ condition, wrapper, children }: ConditonalWrapperProps) =>
  condition ? wrapper(children) : children;

export default ConditonalWrapper;
